import React from 'react'
import Dashboard from '../components/Dashboard'


function Profile() {

  
  return (
    <div>
    
    <h1>Dashboard personal</h1>
    <div className="calendar">
    <Dashboard /> 
    </div>
    
    </div>
  )
}

export default Profile